module.exports = __webpack_public_path__ + "img/gep_es_adatgyujtes_beallitas_pop_up.97953d9f.png";